/** @type {ReturnType<typeof setTimeout> | undefined} */
let t;
/** @type {MutationObserver | undefined} */
let obs;
const go = () => {
  if (!obs) {
    const g = document.getElementById('ResultsList') || document.querySelector('.product-grid');
    if (!g) return;
    obs = new MutationObserver(go);
    obs.observe(g, { childList: true, subtree: true });
  }
  clearTimeout(t);
  t = setTimeout(() => {
    document.querySelectorAll('product-card').forEach((card) => {
      const box = card.querySelector('.card-gallery') || card;
      if (box.querySelector('.wishlist-hero-custom-button')) return;
      const anchor = card.querySelector("a[href*='/products/']");
      if (!(anchor instanceof HTMLAnchorElement) || !anchor.href) return;
      const handle = anchor.href.match(/\/products\/([^/?#]+)/)?.[1];
      if (!handle) return;
      const btn = document.createElement('div');
      btn.className = 'wishlisthero-floating wishlist-hero-custom-button';
      btn.dataset.wlhHandle = handle;
      btn.dataset.wlhMode = 'icon_only';
      btn.dataset.wlhView = 'Collection';
      box.insertBefore(btn, box.firstChild);
      document.dispatchEvent(new CustomEvent('wishlist-hero-add-to-custom-element', { detail: btn }));
    });
  }, 100);
};
['filter:update', 'shopify:section:load'].forEach((e) => document.addEventListener(e, go));
go();
